import React from 'react';
import get from 'lodash.get';

import styles from './browser.css';

function Browser({ data }) {
  const img = get(data, 'layout_type[0].browser_image');

  return (
    <div className={styles.device}>
      <div className={styles.deviceContent}>
        <img
          data-sizes="auto"
          src={img.sizes.medium}
          data-srcset={[
            `${img.sizes.medium_large} 300w`,
            `${img.sizes.large} 600w`,
            `${img.url} 900w`
          ]}
          className={`${styles.img} lazyload`}
        />
      </div>
    </div>
  );
}

export default Browser;



// WEBPACK FOOTER //
// ./src/components/Browser/Browser.js